import { Component, OnInit } from '@angular/core';
import { BaseTechnicalSectionComponent } from '../../common/base-technical-section.component';
import { EnvironmentService } from 'src/app/services/environment.service';
import { TechnicalSpecificationsFormSections } from 'src/app/+grid-application-shared/entities/enums/ui-collection-types.enum';
import { CommonService } from 'src/app/services/common.service';
import { NetzTranslateService } from 'src/app/services/netz-translate.service';
import { LookupOptionsData } from 'src/app/jurisdiction/jurisdiction.domain';
import { GridApplicationCommentsService } from 'src/app/+grid-application-shared/services/grid-application-comments.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-measurement-concept',
  templateUrl: './measurement-concept.component.html',
  styleUrls: ['./measurement-concept.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class MeasurementConceptComponent extends BaseTechnicalSectionComponent implements OnInit {
  measuringConcepts: LookupOptionsData[];

  constructor(
    commentService: GridApplicationCommentsService,
    environmentService: EnvironmentService,
    private readonly commonService: CommonService,
    private readonly translateService: NetzTranslateService
  ) {
    super(commentService, environmentService);
  }

  public ngOnInit(): void {
    this.initDropdownCollections();
    this.registerForLanguageChange();
  }

  get formSection(): TechnicalSpecificationsFormSections {
    return TechnicalSpecificationsFormSections.ConceptOfMeasurement;
  }

  protected get sectionComment(): string | null {
    return this.technicalData.technical_specifications_sections_state?.concept_of_measurement_comment;
  }

  protected set sectionComment(value: string | null) {
    this.technicalData.technical_specifications_sections_state.concept_of_measurement_comment = value;
  }

  protected get sectionLocked(): boolean | null {
    return this.technicalData.technical_specifications_sections_state?.is_concept_of_measurement_locked;
  }

  protected set sectionLocked(value: boolean | null) {
    this.technicalData.technical_specifications_sections_state.is_concept_of_measurement_locked = value;
  }

  private initDropdownCollections(): void {
    const altMeasuringConcept = this.translateService.translateString('technical-data.alternative-concept');
    const altMeasuringConceptOption: LookupOptionsData = {
      label: altMeasuringConcept,
      value: altMeasuringConcept,
      order: 0,
    };

    this.measuringConcepts = [altMeasuringConceptOption, ...this.commonService.getDropdownData('sk_measuring_concept')];
  }

  private updateDropdownCollections(): void {
    const altMeasuringConcept = this.translateService.translateString('technical-data.alternative-concept');
    this.measuringConcepts[0] = {
      label: altMeasuringConcept,
      value: altMeasuringConcept,
      order: 0,
    };
  }

  private registerForLanguageChange(): void {
    this.preventLeak(this.translateService.registerForLanguageChange()).subscribe(() => {
      this.updateDropdownCollections();
    });
  }
}
